/**
 * Pear `window.pear.bulkConverter` — list conversions, incomplete count, fetch one conversion for CSV.
 * API request/response fields are snake_case.
 */
import * as Sentry from '@sentry/browser'

const PRODUCT_TYPE = 'EDULASTIC'

export async function listConversionsPear({
  statuses,
  conversionIds,
  limit,
  offset,
} = {}) {
  const listConversions = window?.pear?.bulkConverter?.listConversions
  if (!listConversions) return []
  try {
    const args = { productType: PRODUCT_TYPE }
    if (statuses?.length) args.statuses = statuses
    if (conversionIds?.length) {
      args.conversion_ids = conversionIds.map((id) => String(id))
    }
    if (limit != null) args.limit = limit
    if (offset != null) args.offset = offset
    const result = await listConversions(args)
    return result?.conversions ?? []
  } catch (err) {
    Sentry.captureException(err)
    return []
  }
}

export async function fetchConversionByIdPear(conversionId) {
  if (!conversionId) return null
  const id = String(conversionId)
  const list = await listConversionsPear({ conversionIds: [id] })
  return list.find((c) => String(c.conversion_id) === id) ?? null
}

export async function fetchIncompleteConversionsCount({ conversionIds } = {}) {
  try {
    const conversions = await listConversionsPear({
      statuses: ['queued', 'processing'],
      conversionIds,
    })
    return { count: conversions.length }
  } catch {
    return { count: 0 }
  }
}

export const INCOMPLETE_CONVERSIONS_POLL_INITIAL_MS = 5000
export const INCOMPLETE_CONVERSIONS_POLL_MAX_MS = 30000
